package com.anjuros.website.redesign.sections.portal

import androidx.compose.runtime.Composable
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.redesign.components.RdPicture
import com.anjuros.website.redesign.components.RdSection
import com.anjuros.website.redesign.components.RdSectionHead
import com.anjuros.website.redesign.styles.PortalActionsStyle
import com.anjuros.website.redesign.styles.PortalJourneyGridStyle
import com.anjuros.website.redesign.styles.PortalJourneyPhoneStyle
import com.anjuros.website.redesign.styles.PortalJourneyStyle
import com.anjuros.website.redesign.styles.PortalStageBodyStyle
import com.anjuros.website.redesign.styles.PortalStageStatusStyle
import com.anjuros.website.redesign.styles.RdH3Style
import com.anjuros.website.redesign.util.RdImage
import com.anjuros.website.redesign.util.RdText
import com.anjuros.website.redesign.util.rdList
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.dom.Div
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.Li
import org.jetbrains.compose.web.dom.Ol
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Small
import org.jetbrains.compose.web.dom.Text
import org.jetbrains.compose.web.dom.Ul

/** One step of a job; [actions] lists the portal features used at that step. */
private class JobStage(val status: RdText, val title: RdText, val text: RdText, val actions: RdText)

private val JobStages = listOf(
    JobStage(RdText.PORTAL_STAGE1_STATUS, RdText.PORTAL_STAGE1_TITLE, RdText.PORTAL_STAGE1_TEXT, RdText.PORTAL_STAGE1_ACTIONS),
    JobStage(RdText.PORTAL_STAGE2_STATUS, RdText.PORTAL_STAGE2_TITLE, RdText.PORTAL_STAGE2_TEXT, RdText.PORTAL_STAGE2_ACTIONS),
    JobStage(RdText.PORTAL_STAGE3_STATUS, RdText.PORTAL_STAGE3_TITLE, RdText.PORTAL_STAGE3_TEXT, RdText.PORTAL_STAGE3_ACTIONS),
    JobStage(RdText.PORTAL_STAGE4_STATUS, RdText.PORTAL_STAGE4_TITLE, RdText.PORTAL_STAGE4_TEXT, RdText.PORTAL_STAGE4_ACTIONS),
    JobStage(RdText.PORTAL_STAGE5_STATUS, RdText.PORTAL_STAGE5_TITLE, RdText.PORTAL_STAGE5_TEXT, RdText.PORTAL_STAGE5_ACTIONS),
    JobStage(RdText.PORTAL_STAGE6_STATUS, RdText.PORTAL_STAGE6_TITLE, RdText.PORTAL_STAGE6_TEXT, RdText.PORTAL_STAGE6_ACTIONS),
)

/** Every portal feature, placed at the point in a job where you'd use it. */
@Composable
fun PortalJourneySection() {
    RdSection(id = "journey", labelledBy = "journey-h") {
        RdSectionHead(RdText.PORTAL_JOURNEY_EYEBROW, "journey-h", RdText.PORTAL_JOURNEY_TITLE, RdText.PORTAL_JOURNEY_LEDE)
        Div(PortalJourneyGridStyle.toModifier().toAttrs()) {
            Ol(PortalJourneyStyle.toModifier().toAttrs()) {
                JobStages.forEach { stage ->
                    Li {
                        Div(PortalStageBodyStyle.toModifier().toAttrs()) {
                            P(PortalStageStatusStyle.toModifier().toAttrs()) { Text(LocalText(stage.status)) }
                            H3(RdH3Style.toModifier().toAttrs()) { Text(LocalText(stage.title)) }
                            P { Text(LocalText(stage.text)) }
                            Ul(PortalActionsStyle.toModifier().toAttrs()) {
                                rdList(LocalText(stage.actions)).forEach { Li { Text(it) } }
                            }
                        }
                    }
                }
            }
            Div(PortalJourneyPhoneStyle.toModifier().toAttrs()) {
                RdPicture(RdImage.PORTAL_PHONE_ACTIONS, alt = "")
                Small { Text(LocalText(RdText.PORTAL_JOURNEY_PHONE_CAPTION)) }
            }
        }
    }
}
